import React from "react";
import { FoodBox } from "./FoodBox";
import { FoodInfo } from "./FoodInfo";
import "./Food.css";
import FadeIn from "react-fade-in";
import LoadAnim from "../App/LoadAnim.js";
import ApiError from "../Error/ApiError.js";

class Food extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      foodPage: null,
      error: false,
      foodPost: "",
      Foods: [],

      showModal: false,
      showFoodBox: true,
      auth: false
    };

    this.getFoodPage = this.getFoodPage.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.getFoodPage();
  }

  async getFoodPage() {
    try {
      await fetch("/api/pagedata/getFoodPage", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data && data.length > 0 && data[0]) {
            this.setState({ foodPage: data[0] });
            this.setState({ updated: Date().slice(16, 24) });
            this.setState({ error: false });

            if (data[0].foodOpen === true && data[0].noFoodSale === false) {
              this.setState({ foodPost: data[0].foodOpenPost });
            } else if (data[0].foodOpen === true && data[0].noFoodSale === true) {
              this.setState({ foodPost: data[0].noFoodSalePost });
            } else {
              this.setState({ foodPost: data[0].foodClosedPost });
            }
          } else {
            // Handle empty database case
            this.setState({
              foodPage: {
                foodOpen: false,
                noFoodSale: false,
                foodClosedPost: "Food ordering is currently not available.",
                food1Active: false,
                food2Active: false,
                food3Active: false
              },
              foodPost: "Food ordering is currently not available.",
              updated: Date().slice(16, 24),
              error: false
            });
          }

          let activeFoods = [];
          if (data[0].food1Active === true) {
            activeFoods.push({
              Name: data[0].food1Title,
              Description: data[0].food1Description,
              Price: data[0].food1Price,
              ID: 1
            });
          }
          if (data[0].food2Active === true) {
            activeFoods.push({
              Name: data[0].food2Title,
              Description: data[0].food2Description,
              Price: data[0].food2Price,
              ID: 2
            });
          }
          if (data[0].food3Active === true) {
            activeFoods.push({
              Name: data[0].food3Title,
              Description: data[0].food3Description,
              Price: data[0].food3Price,
              ID: 3
            });
          }
          if (data[0].food4Active === true) {
            activeFoods.push({
              Name: data[0].food4Title,
              Description: data[0].food4Description,
              Price: data[0].food4Price,
              ID: 4
            });
          }
          if (data[0].food5Active === true) {
            activeFoods.push({
              Name: data[0].food5Title,
              Description: data[0].food5Description,
              Price: data[0].food5Price,
              ID: 5
            });
          }

          this.setState({ Foods: activeFoods });
        })
        .catch(err => {
          this.setState({ error: true });
          console.log(err);
        });
    } catch (err) {
      this.setState({ error: true });
      console.log(err);
    }
  }

  render() {
    return (
      <div>
        {this.state.error !== true && this.state.foodPage === null && (
          <LoadAnim />
        )}
        <FadeIn>
          {this.state.error && <ApiError />}
          {this.state.foodPage !== null && (
            <div>
              <FoodInfo
                auth={this.state.auth}
                showFoodBox={this.state.showFoodBox}
                foodPost={this.state.foodPost}
              />

              {this.state.foodPage.foodOpen === true &&
                this.state.foodPage.noFoodSale === false && (
                  <FoodBox Foods={this.state.Foods} auth={this.state.auth} />
                )}
            </div>
          )}
        </FadeIn>
      </div>
    );
  }
}
export default Food;



// WEBPACK FOOTER //
// ./src/Components/Food/Food.js